

import {
  KeybindService,
  KeybindDescription,
  KEYBOARD_CODES,
  KEYBOARD_MODIFIERS
} from './keybind.service';

import { ShellService } from './shell.service';

export const SERVICES = [
  KeybindService,
  ShellService,
];

export {
  KeybindDescription,
  KeybindService,
  KEYBOARD_CODES,
  KEYBOARD_MODIFIERS,
  ShellService,
};



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/core/services/index.ts